import angular from 'angular';

export const EMPLOYER_WORKFLOW_STATUS = {
    NONE: 'None',
    RATE: 'Rate',
    CONTACT: 'Contact',
    CONTACTED: 'Contacted',
    REVIEWED: 'Claimed',
    INTERVIEW_AND_ASSESSMENT: 'Interview-Assessment',
    HIRED: 'Hired',
    REJECTED: 'Rejected',
    DECLINED: 'Declined',
    FEEDBACK: 'Feedback',
    SAMPLES: 'Samples',
};

export const WORKFLOW_STEP_UNKNOWN = 'unknown';

angular.module('TALENYA-FE')
    .constant('EMPLOYER_WORKFLOW_STATUS', EMPLOYER_WORKFLOW_STATUS)
    .constant('WORKFLOW_STEP_UNKNOWN', WORKFLOW_STEP_UNKNOWN);
